import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import emoji from 'node-emoji';

// CONSTANTS
import { ROUTE_FIND_MY_BUNDLE } from '@/constants/routes';
import { LOCATIONS_WP_POST_POPUP } from '@/constants/locations';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import { DialogCTAStyled } from '../styles';

const DialogFindMyBundle = props => {
  const [t] = useTranslation();

  const { title, subtitle } = t('WPPost.dialogs.findMyBundle', {
    returnObjects: true,
  });

  return (
    <DialogCTAStyled
      {...props}
      className="find-my-bundle"
      icon={emoji.get(':thinking_face')}
      title={title}
      titleProps={{ align: 'left' }}
      subtitle={subtitle}
      subtitleProps={{ align: 'left' }}
      buttonConfirmProps={{
        component: RouterLink,
        to: ROUTE_FIND_MY_BUNDLE,
        location: LOCATIONS_WP_POST_POPUP,
      }}
      buttonConfirmTitle={t('buttons.findMyBundle')}
      buttonCancelTitle={t('buttons.close')}
    />
  );
};

DialogFindMyBundle.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirmClick: PropTypes.func,
  onCancelClick: PropTypes.func,
};

export default DialogFindMyBundle;
